import styled from 'styled-components';
import { Row } from 'antd';

export const BackgroundRow = styled(Row)`
  background: url(${props => props.background}) no-repeat top center;
  background-size: contain;
`;
